var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "33px",
    viewBox: "0 0 39 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EE48B874-1C44-4752-AE1B-5C5ECAF5698F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.9148523,0.000760792036 C23.7811134,-0.0168619173 20.801897,1.4287518 18.7833333,3.94644106 C16.7773283,1.4115243 13.7899022,-0.0380730601 10.6518143,0.000760792036 C4.76897972,0.000760792036 3.37882558e-15,5.00968782 0,11.1885124 C0,21.7769202 17.5945148,32.1156015 18.3078059,32.515164 C18.5956543,32.7171676 18.9710124,32.7171676 19.2588608,32.515164 C19.9721519,32.1156015 37.5666667,21.9267562 37.5666667,11.1885124 C37.5666667,8.22133622 36.4444252,5.37568781 34.4468225,3.27757738 C32.4492198,1.17946696 29.7398891,0.000760792036 26.9148523,0.000760792036 Z M18.7833333,30.5173512 C16.0252743,28.8192103 1.9021097,19.7791074 1.9021097,11.1885124 C1.9021097,6.11304936 5.81948591,1.99857359 10.6518143,1.99857359 C13.6110321,1.95778046 16.3803647,3.52543988 17.9749367,6.14403513 C18.1627829,6.4160851 18.4633703,6.57711959 18.7833333,6.57711959 C19.1032964,6.57711959 19.4038838,6.4160851 19.59173,6.14403513 C21.7111786,2.73959097 25.7093081,1.20356458 29.4199698,2.36816049 C33.1306315,3.53275641 35.6709305,7.12087695 35.664557,11.1885124 C35.664557,19.8789981 21.5413924,28.8691557 18.7833333,30.5173512 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Profile",
    transform: "translate(-205.000000, -1525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-1.000000, 1502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Profile-Like",
    transform: "translate(200.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6.533333, 8.166667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Maroon",
    mask: "url(#mask-2)",
    fill: "#710D0D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.533333, -8.166667)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.81ba8a55a2568a3459a1e798ac44ca9a.svg";
export { ForwardRef as ReactComponent };